import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ArrowRight, Mail } from "lucide-react";
import { Input } from "./ui/input";
import { getUtm, getSourcePage } from "../lib/utm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterCta() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return toast.error("Please enter a valid email.");
    setSubmitting(true);
    try {
      await axios.post(`${API}/contact`, {
        name: "Newsletter subscriber",
        email,
        subject: "Newsletter subscription",
        message: "Requested the StUpEco Hub resources newsletter.",
        consent: true,
        source_page: getSourcePage(),
        utm: getUtm(),
      });
      setDone(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="relative overflow-hidden rounded-3xl bg-[color:var(--invert-bg)] p-8 text-white lg:p-12" data-testid="newsletter-cta">
      <div className="grid-lines absolute inset-0 opacity-20" />
      <div className="relative z-10 grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-white/60">
            <Mail className="h-4 w-4" /> Newsletter
          </span>
          <h3 className="font-display mt-4 text-2xl font-semibold tracking-tight sm:text-3xl">
            Get business insights in your inbox.
          </h3>
          <p className="mt-3 max-w-md text-white/70">
            Practical playbooks on growth, sales, funding and more — no spam, unsubscribe anytime.
          </p>
        </div>
        <div>
          {done ? (
            <p className="text-lg font-medium text-white" data-testid="newsletter-success">You're subscribed — thanks for joining.</p>
          ) : (
            <form onSubmit={onSubmit} className="flex flex-col gap-3 sm:flex-row" data-testid="newsletter-form">
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="newsletter-email" placeholder="you@company.com" className="h-12 flex-1 rounded-full border-white/20 bg-white/10 text-white placeholder:text-white/50" />
              <button type="submit" disabled={submitting} data-testid="newsletter-submit" className="group inline-flex items-center justify-center gap-1.5 rounded-full bg-white px-6 py-3 text-sm font-semibold text-[color:var(--ink)] transition-transform hover:-translate-y-0.5 disabled:opacity-70">
                {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Subscribe <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></>}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
